<div class="view-content-mode" gaCategory="View Information Panel">
  <!-- Description -->
  <app-view-panel [showHeader]="false" *ngIf="descriptionVisible" [hidden]="!isPopulated" role="complementary" aria-describedby="view-title">
    <!-- Content Blocks: Include Ticker -->
    <div *ngIf="(contentBlocks$ | async)?.length > 0">
      <app-content-blocks [contentBlocks]="contentBlocks$ | async" [include]="contentBlockTypes.Ticker">
      </app-content-blocks>
    </div>

    <app-view-description [(isPopulated)]="isPopulated" [layout]="layout"></app-view-description>

    <!-- Content Blocks: Exclude Ticker -->
    <div *ngIf="(contentBlocks$ | async)?.length > 0">
      <app-content-blocks [contentBlocks]="contentBlocks$ | async" [exclude]="contentBlockTypes.Ticker">
      </app-content-blocks>
    </div>

  </app-view-panel>

  <!-- Legend -->
  <app-view-panel label="Legend" *ngIf="(chapter$ | async)?.legend && (chapter$ | async)?.legend.length > 0 && legendVisible">
    <app-view-legend [legend]="(chapter$ | async).legend"></app-view-legend>
  </app-view-panel>

  <!-- Labels -->
  <app-view-panel label="Labels" *ngIf="(labels$ | async)?.length && labelListVisible" role="complementary" aria-label="Labels">

    <!-- Label actions -->
    <div actions *ngIf="(labels$ | async)?.length > 1" class="flex">
      <button
        gaEvent
        gaAction="Clicked Previous Label"
        app-pin-button
        icon="chevron-left"
        size="small"
        buttonType="ghost" 
        aria-label="Previous Label"
        matTooltip="Previous Label"
        (click)="handlePrevClick()">
      </button>

      <button
        gaEvent
        gaAction="Clicked Next Label"
        app-pin-button
        icon="chevron-right"
        size="small"
        buttonType="ghost" 
        aria-label="Next Label"
        matTooltip="Next Label"
        (click)="handleNextClick()">
      </button>

    </div>

    <app-view-labels></app-view-labels>
  </app-view-panel>
</div>